import React, { createContext, useContext, ReactNode } from 'react';

interface LayoutContextType {
  sidebarCollapsed?: boolean;
  sidebarOpen?: boolean;
  isMobile?: boolean;
  setSidebarCollapsed?: (collapsed: boolean) => void;
  setSidebarOpen?: (open: boolean) => void;
}

const LayoutContext = createContext<LayoutContextType | undefined>(undefined);

export const useLayout = () => {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error('useLayout must be used within a LayoutProvider');
  }
  return context;
};

interface LayoutProviderProps {
  children: ReactNode;
  sidebarCollapsed?: boolean;
  sidebarOpen?: boolean;
  isMobile?: boolean;
  setSidebarCollapsed?: (collapsed: boolean) => void;
  setSidebarOpen?: (open: boolean) => void;
}

export const LayoutProvider: React.FC<LayoutProviderProps> = ({
  children,
  sidebarCollapsed,
  sidebarOpen,
  isMobile,
  setSidebarCollapsed,
  setSidebarOpen,
}) => {
  const value: LayoutContextType = {
    ...(sidebarCollapsed !== undefined && { sidebarCollapsed }),
    ...(sidebarOpen !== undefined && { sidebarOpen }),
    ...(isMobile !== undefined && { isMobile }),
    ...(setSidebarCollapsed && { setSidebarCollapsed }),
    ...(setSidebarOpen && { setSidebarOpen }),
  };

  return (
    <LayoutContext.Provider value={value}>
      {children}
    </LayoutContext.Provider>
  );
};
